import { useEffect, useState } from 'react';

import cx from '../../../../utils/cx';
import useAnimatedNumber from '../useAnimatedNumber';

import Typography, { FONT_TYPES } from '../Typography/Typography';

import { LOADER_FIRST_PHRASE_DELAY, LOADER_PHRASE_INTERVAL } from '../../../../config/quiz';

import styles from './ProgressCard.module.scss';

const TICKS_COUNT = 30;

const ProgressCard = ({ title, subtitle, phrases, progress, prevProgress, isLoader }) => {
  const value = useAnimatedNumber({ from: prevProgress, to: progress });
  const filledTicks = Math.round((TICKS_COUNT * value) / 100);

  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    if (!isLoader) {
      setPhraseIndex(0);

      return undefined;
    }

    if (phraseIndex >= phrases.length - 1) return undefined;

    const delay = phraseIndex === 0 ? LOADER_FIRST_PHRASE_DELAY : LOADER_PHRASE_INTERVAL;

    const timerId = setTimeout(() => {
      setPhraseIndex((prev) => prev + 1);
    }, delay);

    return () => clearTimeout(timerId);
  }, [isLoader, phraseIndex, phrases.length]);

  return (
    <div className={cx(styles.card, { [styles.cardLoader]: isLoader })}>
      <div className={styles.texts}>
        <Typography type={FONT_TYPES.body_bold} htmlTag="p" className={styles.title}>
          {title}
        </Typography>
        <div className={styles.subtitleBox}>
          <Typography type={FONT_TYPES.small_regular} htmlTag="p" className={styles.subtitle}>
            {subtitle}
          </Typography>
          {isLoader && (
            <Typography
              key={phraseIndex}
              type={FONT_TYPES.small_regular}
              htmlTag="p"
              className={styles.phrase}
            >
              {phrases[phraseIndex]}
            </Typography>
          )}
        </div>
      </div>
      <div className={styles.progress}>
        <div className={styles.ticks}>
          {Array.from({ length: TICKS_COUNT }, (_, index) => (
            <span
              key={index}
              className={cx(styles.tick, { [styles.tickFilled]: index < filledTicks })}
            />
          ))}
        </div>
        <Typography type={FONT_TYPES.percent} htmlTag="span" className={styles.percent}>
          {`${value}%`}
        </Typography>
      </div>
      <div className={styles.spinnerBox}>
        <span className={styles.spinner} />
      </div>
    </div>
  );
};

export default ProgressCard;
